import React, {useState} from "react";
import {connect} from "react-redux";

import MaterialSpinner from "../../../../ui/materialSpinner";

const LookFeatureInfoAug = (props) => {

  const [isLoading, toggleLoader] = useState(true);

  const {lookActiveFeature} = props;

  return (
    <div className="lk-info__qr">
      <span className="lk-info__qr-corners lk-info__qr-corners--top"/>
      <span className="lk-info__qr-corners lk-info__qr-corners--bottom"/>
      {isLoading ? <MaterialSpinner/> : null}
      <img src={lookActiveFeature.dbFeature.lixilQRCode}
           alt="qr code"
           className="lk-info__qr-image"
           onLoadStart={() => toggleLoader(true)}
           onLoad={() => toggleLoader(false)}/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature} = store.lookState;
  // const {windowWidth, windowHeight} = store.serverState;
  return {
    lookActiveFeature,
    // windowWidth,
    // windowHeight
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(LookFeatureInfoAug)
